import { Fragment, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { useTranslation } from "react-i18next";

import { ISkuQty } from "../../../types/Inventory/item";
import { IBreadcrumbsAndMenu } from "../../../types/global";

import { Box, Typography } from "@mui/material";

import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import CurrentStockByLocationReportTable from "../../../components/Table/Inventory/Report/CurrentStockByLocationReportTable";
import CustomizedButton from "../../../components/Custom/CustomizedButton";
import { useInventoryReport } from "../../../hooks/Inventory/use-inventory-report";
import { InventoryReportType } from "../../../generated/inventory";

const CurrentStockByLocationReport = () => {
  const gridRef = useRef<AgGridReact<ISkuQty>>(null);
  const { t } = useTranslation();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("inventory.index"),
      to: "/inventory",
    },
    {
      name: t("report"),
      to: "/inventory/report",
    },
    {
      name: "จำนวน" + t("inventory.itemCurrentStockLocation.index"),
    },
  ];

  const { onBtnExport, isExporting, isFetching } = useInventoryReport(
    gridRef,
    InventoryReportType.CurrentStockByLocation
  );

  return (
    <Fragment>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" my={3}>
          จำนวน{t("inventory.itemCurrentStockLocation.index")}
        </Typography>
        <CustomizedButton
          title={`${t("button.export")}`}
          variant="contained"
          onClick={onBtnExport}
          disabled={isExporting && isFetching}
        />
      </Box>
      <CurrentStockByLocationReportTable gridRef={gridRef} />
    </Fragment>
  );
};

export default CurrentStockByLocationReport;
